import React, { forwardRef } from "react";

export interface TabProps {
  children: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
}

export const Tab = forwardRef<HTMLButtonElement, TabProps>(
  ({ children, isActive, onClick }, ref) => (
    <button
      ref={ref}
      type="button"
      role="tab"
      aria-selected={isActive}
      tabIndex={isActive ? 0 : -1}
      className={`tab ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
);

Tab.displayName = "Tab";
